import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { makeStyles } from "tss-react/mui";
import { hideDialog } from "../../../dialog/actions";
import { IconCloseLarge } from "../../../icons/svg";
import { operatesWithEnterKey } from "../../functions.web";
import BaseDialog from "./BaseDialog";
import Button from "./Button";
import ClickableIcon from "./ClickableIcon";
const useStyles = makeStyles()((theme) => {
    return {
        header: {
            width: "100%",
            padding: "24px",
            boxSizing: "border-box",
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            borderBottom: "1px solid #e5eef9",
        },
        title: {
            color: "#4b6790",
            fontWeight: 600,
            fontSize: "18px",
            // ...withPixelLineHeight(theme.typography.heading5),
            margin: 0,
            padding: 0,
        },
        content: {
            height: "auto",
            overflowY: "auto",
            width: "100%",
            boxSizing: "border-box",
            padding: "4px 24px",
            overflowX: "hidden",
            minHeight: "40px",
            color: "#4b6790",
            backgroundColor: "#ffffff",
            "@media (max-width: 448px)": {
                height: "100%",
            },
        },
        footer: {
            width: "100%",
            boxSizing: "border-box",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            padding: "24px",
            borderTop: "1px solid #e5eef9",
            backgroundColor: "#f8fbff",
            "& button:last-child": {
                marginLeft: "16px",
            },
        },
    };
});
const Dialog = ({ back = { hidden: true }, cancel = { translationKey: "dialog.Cancel" }, children, className, description, disableAutoHideOnSubmit = false, disableBackdropClose, hideCloseButton, disableEnter, disableEscape, ok = { translationKey: "dialog.Ok" }, onCancel, onSubmit, size, testId, title, titleKey, }) => {
    var _a, _b, _c;
    const { classes } = useStyles();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const onClose = useCallback(() => {
        dispatch(hideDialog());
        onCancel === null || onCancel === void 0 ? void 0 : onCancel();
    }, [onCancel]);
    const submit = useCallback(() => {
        if (onSubmit &&
            ((document.activeElement &&
                !operatesWithEnterKey(document.activeElement)) ||
                !document.activeElement)) {
            !disableAutoHideOnSubmit && dispatch(hideDialog());
            onSubmit();
        }
    }, [onSubmit]);
    return (React.createElement(BaseDialog, { className: className, description: description, disableBackdropClose: disableBackdropClose, disableEnter: disableEnter, disableEscape: disableEscape, onClose: onClose, size: size, submit: submit, testId: testId, title: title, titleKey: titleKey },
        React.createElement("div", { className: classes.header },
            React.createElement("h1", { className: classes.title, id: "dialog-title" }, title !== null && title !== void 0 ? title : t(titleKey !== null && titleKey !== void 0 ? titleKey : "")),
            !hideCloseButton && (React.createElement(ClickableIcon, { accessibilityLabel: t("dialog.accessibilityLabel.close"), icon: IconCloseLarge, id: "modal-header-close-button", onClick: onClose }))),
        React.createElement("div", { className: classes.content, "data-autofocus-inside": "true" }, children),
        React.createElement("div", { className: classes.footer, "data-autofocus-inside": "true" },
            !back.hidden && (React.createElement(Button, { accessibilityLabel: t((_a = back.translationKey) !== null && _a !== void 0 ? _a : ""), labelKey: back.translationKey, onClick: back.onClick, type: "secondary" })),
            !cancel.hidden && (React.createElement(Button, { accessibilityLabel: t((_b = cancel.translationKey) !== null && _b !== void 0 ? _b : ""), labelKey: cancel.translationKey, onClick: onClose, type: "tertiary" })),
            !ok.hidden && (React.createElement(Button, Object.assign({ accessibilityLabel: t((_c = ok.translationKey) !== null && _c !== void 0 ? _c : ""), disabled: ok.disabled, id: "modal-dialog-ok-button", isSubmit: true, labelKey: ok.translationKey }, (!ok.disabled && { onClick: submit })))))));
};
export default Dialog;
